import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { SkeletonLoaderComponent } from '../../skeleton-loader/skeleton-loader.component';

type CardBaseAppearance = 'default' | 'filled' | 'stroked';
type CardBaseColor = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';

@Component({
  selector: 'app-card-base',
  imports: [CommonModule, SkeletonLoaderComponent],
  templateUrl: './card-base.component.html',
  styleUrls: ['./card-base.component.scss'],
  standalone: true,
})
export class CardBaseComponent {
  @Input() appearance: CardBaseAppearance = 'default';
  @Input() color: CardBaseColor;
  @Input() loading = false;

  @HostBinding('class.card') readonly isCard = true;

  // appearance
  @HostBinding('class.card--default') get isDefault() {
    return this.appearance === 'default';
  }
  @HostBinding('class.card--filled') get isFilled() {
    return this.appearance === 'filled';
  }
  @HostBinding('class.card--stroked') get isStroked() {
    return this.appearance === 'stroked';
  }

  // colors
  @HostBinding('class.card--primary') get isPrimary() { return this.color === 'primary'; }
  @HostBinding('class.card--success') get isSuccess() { return this.color === 'success'; }
  @HostBinding('class.card--warning') get isWarning() { return this.color === 'warning'; }
  @HostBinding('class.card--danger') get isDanger() { return this.color === 'danger'; }
  @HostBinding('class.card--info') get isInfo() { return this.color === 'info'; }
  @HostBinding('class.card--neutral') get isNeutral() { return this.color === 'neutral'; }
}
